// extracted by mini-css-extract-plugin
export var card = "_m0-5";
export var cardSelected = "_m0-4";
export var image = "_m0-3";
export var modal = "_m0-0";
export var modalContent = "_m0-1";
export var table = "_m0-2";